import React from "react"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import {WalletTerms, disableWalletTerms, enableWalletTerms} from "../../resources/walletTerms"

interface ToggleWalletTermsProps {
	walletTerms: WalletTerms
	disable: boolean
	close: () => void
	onSuccess: () => void
}
function refreshAndClose(refresh: () => void, close: () => void) {
	return function () {
		refresh()
		close()
	}
}

export function ToggleWalletTermsModal({walletTerms, disable, close, onSuccess}: ToggleWalletTermsProps) {
	const accessToken = useAccessToken()
	const [state, action] = disable ? useAsyncResultIdle(disableWalletTerms) : useAsyncResultIdle(enableWalletTerms)
	const titleText = disable ? "disable" : "enable"
	const buttonClassname = disable ? "is-danger" : "is-black"
	const buttonText = disable ? "Disable" : "Enable"
	const successText = disable ? "Disabled" : "Enabled"

	return (
		<AsyncResultModal
			title={`You are about to ${titleText} ${walletTerms.attributes.name} \r\n Wallet Terms`}
			close={refreshAndClose(onSuccess, close)}
			buttonClassname={buttonClassname}
			state={state}
			buttonText={buttonText}
			successText={successText}
			onSubmit={() => action(accessToken, walletTerms)}
			errorToText={(err) => err.errors[0].title}
		>
			<p>Are you sure you want to continue?</p>
		</AsyncResultModal>
	)
}
